import { useSeasonStore } from '@/stores/useSeasonStore';

const env = import.meta.env.VITE_ENV;
const PORT_BACK_DARTSHUB: string = import.meta.env.VITE_PORT_BACK_DARTSHUB;
const PORT_BACK_BADARTS: string = import.meta.env.VITE_PORT_BACK_BADARTS;
const PORT_BACK_CMER: string = import.meta.env.VITE_PORT_BACK_CMER;

export const backend_url =
  env === 'dev'
    ? `http://localhost:${PORT_BACK_DARTSHUB}`
    : 'https://api.dartshub.fr';

export const auth_url =
  env === 'dev'
    ? `http://localhost:${PORT_BACK_DARTSHUB}`
    : 'https://auth.dartshub.fr';

export const badarts_url =
  env === 'dev'
    ? `http://localhost:${PORT_BACK_BADARTS}`
    : 'https://api.badarts.fr';

export const cmer_url =
  env === 'dev'
    ? `http://localhost:${PORT_BACK_CMER}`
    : 'https://api.cmerdarts.fr';

// Source unique : la saison courante est calculée par Dartshub/backend (table `seasons`)
// et exposée via /seasons ; useSeasonStore() la met en cache côté client.
export const getCurrentSeason = (): string => useSeasonStore().currentSeason;
